export const formatBalance = (balance) =>
  Number.isSafeInteger(balance) ? balance.toLocaleString("en") : "0";
